module.exports = __webpack_public_path__ + "56ca64a9.woff";